import { Helmet } from 'react-helmet-async'
import Footer from '../components/Footer'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../config/supabase'
import { useEffect, useState } from 'react'

// เพิ่มฟังก์ชัน formatDate
const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

const VIP = () => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const [profile, setProfile] = useState(null)
  const [hasSubscriptionHistory, setHasSubscriptionHistory] = useState(false)
  const [isLifetimeMember, setIsLifetimeMember] = useState(false)

  useEffect(() => {
    if (user) {
      getProfile()
    }
  }, [user])

  const getProfile = async () => {
    try {
      // ดึงข้อมูล profile
      const { data: profileData, error: profileError } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .single()

      if (profileError) throw profileError
      setProfile(profileData)

      // เช็คประวัติการซื้อแพ็กเกจรายเดือน
      const { data: paymentData, error: paymentError } = await supabase
        .from('payments')
        .select('*')
        .eq('user_id', user.id)
        .eq('package_id', 1) // package_id 1 คือแพ็กเกจรายเดือน
        .eq('payment_status', 'approved')

      if (paymentError) throw paymentError
      setHasSubscriptionHistory(paymentData.length > 0)

      // แก้ไขการเช็คสถานะ lifetime
      setIsLifetimeMember(profileData.membership === 'lifetime')
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const plans = [
    {
      name: 'Free',
      price: 'ฟรี',
      color: 'green',
      features: [
        'สร้าง Prompt ธรรมดาได้ไม่จำกัด',
        'ใช้งานฟีเจอร์พื้นฐาน',
        'ใช้งาน Extension ฟรีได้',
      ],
    },
    {
      name: 'VIP',
      price: (
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-2">
            <span className="text-3xl font-bold">799.-</span>
          </div>
          <div className="mt-1 flex items-center gap-2">
            <span className="text-sm text-gray-400">ต่ออายุเพียง</span>
            <span className="text-lg font-bold bg-gradient-to-r from-yellow-200 to-yellow-500 text-transparent bg-clip-text animate-pulse">
              99฿/เดือน
            </span>
          </div>
          <div className="mt-1 flex items-center gap-2">
            <span className="text-sm text-gray-400">แพคเกจรายปี</span>
            <span className="text-lg font-bold bg-gradient-to-r from-green-200 to-green-500 text-transparent bg-clip-text">
              1,399฿
            </span>
            <span className="bg-green-500/20 px-2 py-0.5 rounded-full text-xs text-green-400">
              จากปกติ 1,888฿
            </span>
          </div>
        </div>
      ),
      color: 'yellow',
      features: [
        <div className="flex items-center gap-2">
          <span className="font-bold text-lg bg-gradient-to-r from-yellow-200 to-yellow-500 text-transparent bg-clip-text">
            สร้าง Prompt ด้วย AI
          </span>
        </div>,
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <span className="font-bold bg-gradient-to-r from-red-200 to-red-500 text-transparent bg-clip-text">
              AI Unlock Custom GPT 🤖
            </span>
            <span className="bg-red-500/20 px-2 py-0.5 rounded text-xs text-red-400">
              New
            </span>
          </div>
          <ul className="pl-5 space-y-1 text-sm text-gray-400">
            <li className="flex items-center gap-2">
              <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              แนะนำคีย์เวิร์ดน่าทำ
            </li>
            <li className="flex items-center gap-2">
              <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              แตกคียเวิรด์แบบต่างๆ
            </li>
            <li className="flex items-center gap-2">
              <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              สร้าง Prompt แบบมืออาชีพ
            </li>
            <li className="flex items-center gap-2">
              <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              อื่นๆที่มี และในอนาคต
            </li>
            <li className="flex items-center gap-2">
              <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span className="font-bold text-yellow-400">
                สมัครครั้งเดียวใช้ได้ตลอด
              </span>
            </li>
          </ul>
        </div>,
        <div className="flex items-center gap-2">
          <span className="font-bold bg-gradient-to-r from-yellow-200 to-yellow-500 text-transparent bg-clip-text">
            เครื่องมือ VIP ทั้งหมด⚡️
          </span>
        </div>,
        <div className="flex items-center gap-2">
          <span className="font-bold bg-gradient-to-r from-yellow-200 to-yellow-500 text-transparent bg-clip-text">
            บทเรียนออนไลน์จับมือทำ 0-100
          </span>
        </div>,
        <div className="flex items-center gap-2">
        <span className="font-bold bg-gradient-to-r from-yellow-200 to-yellow-500 text-transparent bg-clip-text">
          SellJung ระดับ Gold
        </span>
        <span className="bg-red-500/20 px-2 py-0.5 rounded-full text-xs text-red-400 animate-pulse">
          หมด
        </span>
      </div>,
        <div className="flex items-center gap-2">
          <span className="font-bold bg-gradient-to-r from-yellow-200 to-yellow-500 text-transparent bg-clip-text">
            สอบถามส่วนตัวได้ตลอด⚡️
         </span>
       </div>,
      ],
      recommended: true,
      badge: 'Popular'
    },
    {
      name: 'Lifetime',
      price: (
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-2">
            <span className="text-3xl font-bold">2,399-</span>
          </div>
          <div className="mt-1 flex items-center gap-2">
            <span className="text-sm text-gray-400">จ่ายครั้งเดียวจบ</span>
          </div>
          <div className="mt-2 flex items-center gap-2">
            <span className="bg-red-500/20 px-3 py-1 rounded-full text-xs text-red-400 animate-pulse font-medium">
              รับสมัครจำนวนจำกัด
            </span>
            <span className="bg-red-500/20 px-3 py-1 rounded-full text-xs text-red-400">
              เหลือ 20 ที่
            </span>
          </div>
          
        </div>
      ),
      color: 'red',
      features: [
        'สิทธิประโยชน์เหมือน VIP ทั้งหมด',
        'จ่ายครั้งเดียวจบ',
        <div className="flex items-center gap-2">
          <span className="font-bold bg-gradient-to-r from-blue-200 to-blue-500 text-transparent bg-clip-text">
            SellJung ระดับ Diamond
          </span>
          <span className="bg-red-500/20 px-2 py-0.5 rounded-full text-xs text-red-400 animate-pulse">
            หมด
          </span>
        </div>,
                <div className="flex items-center gap-2">
                <span className="font-bold bg-gradient-to-r from-blue-200 to-blue-500 text-transparent bg-clip-text">
                  รับสมัครจำนวนจำกัด
                </span>
                <span className="bg-blue-500/20 px-2 py-0.5 rounded text-xs text-blue-400">
                  limited
                </span>
              </div>

      ],
      type: 'lifetime',
      badge: 'Best Value'
    }
  ]

  const vipBenefits = [
    {
      title: 'สร้าง Prompt AI',
      description: 'สร้าง Prompt จากคีย์เวิร์ดด้วย AI GEMINI ,OPENAI และสามารถตั้งค่า พารามิเตอร์ต่างๆได้อย่างสะดวกสบาย ทำให้คุณทำงานได้ไวขึ้นมาก',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
      )
    },
    {
      title: (
        <div className="flex items-center gap-2">
          <span>SellJung Free</span>
          <span className="bg-red-500/20 px-2 py-0.5 rounded-full text-xs text-red-400 animate-pulse">ระยะเวลาจำกัด</span>
        </div>
      ),
      description: 'รับระดับสมาชิก Gold , Diamond ของเว็บ SellJung ฟรี เป็นเว็บสำหรับใช้ AI ช่วยสร้างคอนเทนต์ต่างๆ และมีบทเรียนออนไลน์มากมาย',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
      )
    },
    {
      title: 'โซน VIP',
      description: 'เข้าถึงโซน VIP ที่มีเครื่องมือ VIP, เทคนิคพิเศษ และเนื้อหาพรีเมียมมากมาย อัพเดทฟรี',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
      )
    },
    {
      title: 'Discord VIP',
      description: 'เข้าร่วมชุมชนพิเศษใน Discord พูดคุยแลกเปลี่ยนกับสมาชิกระดับ VIP คนอื่นๆ',
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
      )
    }
  ];

  // ย้ายฟังก์ชัน handleClick มาไว้ในนี้
  const handleClick = (plan) => {
    if (!user) {
      navigate('/login')
      return
    }

    switch (plan) {
      case 'monthly':
        navigate('/payment?plan=monthly')
        break
      case 'yearly':
        navigate('/payment?plan=yearly')
        break
      case 'lifetime':
        navigate('/payment?plan=lifetime')
        break
      default:
        navigate('/register')
    }
  }

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Helmet>
        <title>แพ็กเกจสมาชิก</title>
      </Helmet>
      <main className="flex-grow">
        <div className="max-w-6xl mx-auto p-6">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">แพ็กเกจสมาชิก</h1>
            <p className="text-gray-400">เลือกแพ็กเกจที่เหมาะกับคุณ</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {plans.map((plan) => (
              <div 
                key={plan.name}
                className={`
                  bg-gray-900 rounded-lg p-6 border 
                  ${plan.name === 'VIP' 
                    ? 'border-yellow-500/50 bg-gradient-to-br from-yellow-500/10 to-yellow-600/10' 
                    : plan.name === 'Lifetime'
                    ? 'border-red-500/50 bg-gradient-to-br from-red-500/10 to-rose-600/10'
                    : plan.name === 'Free'
                    ? 'border-green-500/50 bg-gradient-to-br from-green-500/10 to-emerald-600/10'
                    : 'border-gray-700'
                  }
                  ${plan.recommended ? 'ring-2 ring-yellow-500 transform scale-105' : ''}
                  flex flex-col relative
                `}
              >
                {(plan.name === 'VIP' || plan.name === 'Lifetime' || plan.name === 'Free') && (
                  <div className="absolute inset-0 z-0">
                    <div className={`
                      absolute -inset-x-32 -top-32 h-[200px] w-96 opacity-30 blur-3xl transform rotate-12
                      ${plan.name === 'VIP' ? 'bg-yellow-500' : 
                        plan.name === 'Lifetime' ? 'bg-red-500' : 
                        'bg-green-500'}
                    `}/>
                  </div>
                )}

                {plan.badge && (
                  <div className="absolute -top-3 -right-3 z-20">
                    <div className="relative">
                      <div className="absolute inset-0">
                        <div className={`
                          absolute inset-0 rounded-full animate-pulse
                          ${plan.badge === 'Popular' 
                            ? 'bg-yellow-500/50' 
                            : plan.badge === 'Best Value'
                            ? 'bg-red-500/50'
                            : ''
                          }
                        `}></div>
                      </div>
                      <span className={`
                        relative inline-flex items-center px-4 py-1 rounded-full text-xs font-medium transform -rotate-12
                        ${plan.badge === 'Popular' 
                          ? 'bg-yellow-500 text-black' 
                          : plan.badge === 'Best Value'
                          ? 'bg-red-500 text-white'
                          : ''
                        }
                      `}>
                        {plan.badge}
                      </span>
                    </div>
                  </div>
                )}

                <div className="text-center mb-6 relative z-10">
                  <h2 className={`text-2xl font-bold mb-2 ${
                    plan.name === 'VIP' 
                      ? 'text-yellow-400 bg-gradient-to-r from-yellow-200 to-yellow-500 text-transparent bg-clip-text' 
                      : plan.name === 'Lifetime'
                      ? 'text-red-400 bg-gradient-to-r from-red-200 to-rose-500 text-transparent bg-clip-text'
                      : plan.name === 'Free'
                      ? 'text-green-400 bg-gradient-to-r from-green-200 to-emerald-500 text-transparent bg-clip-text'
                      : `text-${plan.color}-400`
                  }`}>
                    {plan.name}
                  </h2>
                  <div>
                    <div className="text-3xl font-bold mb-1">
                      {plan.price}
                    </div>
                  </div>
                </div>

                <div className="flex-grow relative z-10">
                  <ul className="space-y-3 mb-6">
                    {plan.features.map((feature, index) => (
                      <li key={index} className="flex items-center gap-2">
                        <svg 
                          className={`w-5 h-5 ${
                            plan.name === 'VIP' 
                              ? 'text-yellow-400' 
                              : plan.name === 'Lifetime'
                              ? 'text-green-400'
                              : `text-${plan.color}-400`
                          } flex-shrink-0`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                        <span className="text-gray-300">{feature}</span>
                      </li>
                    ))}
                    {plan.limitations?.map((limitation, index) => (
                      <li key={index} className="flex items-center gap-2">
                        <svg 
                          className="w-5 h-5 text-gray-600 flex-shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                        <span className="text-gray-500">{limitation}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {plan.name === 'Free' && (
                  <div className="text-center py-3 text-gray-400">
                    เร็วๆ นี้
                  </div>
                )}

                {plan.name === 'VIP' && (
                  <div className="space-y-3 relative z-50">
                    {profile?.membership === 'lifetime' ? (
                      <div className="text-center py-3 text-gray-400">
                        คุณเป็นสมาชิกตลอดชีพแล้ว
                      </div>
                    ) : profile?.membership === 'vip' ? (
                      <>
                        <button 
                          onClick={() => navigate('/payment?plan=renewal')}
                          className="w-full py-3 rounded-lg font-semibold bg-yellow-500 hover:bg-yellow-600 text-black transition-colors relative z-50"
                        >
                          ต่ออายุ VIP 99฿
                        </button>
                        <div className="text-sm text-gray-400 text-center">
                          สำหรับสมาชิกที่เคยสมัครแล้ว
                        </div>
                        <button 
                          onClick={() => navigate('/payment?plan=yearly')}
                          className="w-full py-3 rounded-lg font-semibold bg-green-600 hover:bg-green-700 text-white transition-colors relative z-50"
                        >
                          สมัครสมาชิกรายปี 1,399฿
                        </button>
                      </>
                    ) : (
                      <>
                        <button 
                          onClick={() => !user ? navigate('/login') : navigate('/payment?plan=monthly')}
                          className="w-full py-3 rounded-lg font-semibold bg-yellow-500 hover:bg-yellow-600 text-black transition-colors relative z-50"
                        >
                          สมัครสมาชิกครั้งแรก 799฿
                        </button>
                        <div className="text-sm text-gray-400 text-center">
                          ต่ออายุ รายเดือน 99.-
                        </div>
                        <button 
                          onClick={() => !user ? navigate('/login') : navigate('/payment?plan=yearly')}
                          className="w-full py-3 rounded-lg font-semibold bg-green-600 hover:bg-green-700 text-white transition-colors relative z-50"
                        >
                          สมัครสมาชิกรายปี 1,399฿
                        </button>
                      </>
                    )}
                  </div>
                )}

                {plan.name === 'Lifetime' && (
                  <div className="space-y-3 relative z-50">
                    {profile?.membership === 'lifetime' ? (
                      <div className="text-center py-3 text-gray-400">
                        คุณเป็นสมาชิกตลอดชีพแล้ว
                      </div>
                    ) : (
                      <button 
                        onClick={() => !user ? navigate('/login') : navigate('/payment?plan=lifetime')}
                        className="w-full py-4 rounded-lg font-semibold bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white transition-all duration-200 relative z-100"
                      >
                        สมัครสมาชิก VIP ตลอดชีพ
                      </button>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-24">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">สิทธิประโยชน์สมาชิก VIP</h2>
              <p className="text-gray-400">เพิ่มประสิทธิภาพการใช้งานของคุณด้วฟีเจอร์สุดพิเศษ</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {vipBenefits.map((benefit, index) => (
                <div 
                  key={index}
                  className="bg-gray-900/50 rounded-lg p-6 border border-gray-800 hover:border-yellow-500/50 transition-colors"
                >
                  <div className="flex items-start gap-4">
                    <div className="p-3 bg-yellow-500/10 rounded-lg">
                      <svg 
                        className="w-6 h-6 text-yellow-400" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        {benefit.icon}
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold mb-2 text-yellow-400">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-400 leading-relaxed">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-16 text-center">
              <button 
                onClick={() => handleClick('monthly')}
                className="bg-yellow-500 text-black px-8 py-4 rounded-lg font-semibold hover:bg-yellow-400 transition-colors inline-flex items-center gap-2"
              >
                สมัครสมาชิก VIP เลย
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-12 text-center text-gray-400">
            <p>
              มีคำถาม? {' '}
              <a 
                href="https://discord.com/invite/MxgKZkydXJ" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-yellow-400 hover:text-yellow-300 underline"
              >
                ติดต่อเราได้ที่ Discord
              </a>
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default VIP